import React, { useState, useRef } from "react";
import { Box, TextField, Tooltip, Typography } from "@mui/material";
import PageConverter from "../Function/PageConverter";
import Loading from "../components/Loading";
import Layout from "../Function/Layout";
import axios from "axios";
import { GetJsonAPI } from "../API";
// import ddata from "../Pages/dt.json";
import { Steper } from "../components/MUI/Step";
import Button from "../components/MUI/Button";
const PageConverterPage = ({ showToolbar }) => {
  const longLoadingTimer = useRef();
  const [data, setData] = useState("");
  const [figmaUrl, setFigmaUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileId, setFileId] = useState("");
  const [longLoading, setLongLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  function parseFigmaUrl(url) {
    try {
      const parsed = new URL(url);

      const parts = parsed.pathname.split("/");
      let fileId = parts[2];
      if (parts[1] === "design") {
        parts[1] = "file";
        fileId = parts[2];
      }
      let nodeId = parsed.searchParams.get("node-id");
      if (nodeId) {
        nodeId = nodeId.replace(/-/g, ":");
      }

      return { fileId, nodeId };
    } catch (err) {
      throw new Error("Invalid Figma URL");
    }
  }
  const handleFigmaUrl = async () => {
    try {
      if (!figmaUrl) {
        alert("Please enter a Figma URL");
        return;
      }
      setData("");
      setFileId("");
      setLoading(true);
      setLongLoading(false);
      // Set a timer for 30 seconds to show long loading message
      longLoadingTimer.current = setTimeout(() => {
        setLongLoading(true);
      }, 30000);
      const { fileId, nodeId } = parseFigmaUrl(figmaUrl);
      setFileId(fileId);

      const response = await axios.post(GetJsonAPI, {
        figmaUrl: figmaUrl,
      });

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const jsonResponse = response.data;
      setData(jsonResponse);
    } catch (error) {
      alert(`Error fetching Figma data: ${error.message}`);
    } finally {
      setLoading(false);
      setLongLoading(false);
      // Clear the timer if it hasn't fired
      if (longLoadingTimer.current) clearTimeout(longLoadingTimer.current);
    }
  };

  const handleCreatePage = async () => {
    if (!data || !data.page?.name) {
      alert("No data available or page name not found");
      return;
    }

    const pageName = data.page.name;

    try {
      const serverUrl = "http://localhost:8080/createPage";

      const response = await fetch(serverUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PageName: pageName,
          jsonData: data,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert(
          `✅ ${result.message}\n\nFiles created:\n• ${result.files?.index}\n• ${result.files?.json}`,
        );
      } else {
        alert(`❌ Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error creating page:", error);
      alert(
        `❌ Error creating page: ${error.message}\n\nMake sure the server is running on http://localhost:8080`,
      );
    }
  };

  function hasNavigationBar(structure) {
    if (!Array.isArray(structure)) return false;
    for (const item of structure) {
      if (item.type === "Navigation Bar") return true;
      if (item.children && hasNavigationBar(item.children)) return true;
    }
    return false;
  }

  return (
    <>
      {hasNavigationBar(data?.structure) ? (
        <Layout>
          <PageConverter jsonData={data} />
        </Layout>
      ) : data?.isStepper ? (
        <Layout
          isNavbar={data?.isNavbar}
          isSidebar={data?.isSidebar}
          isSubNavbar={data?.isSubNavbar}
          subNavbarData={{
            ...{
              style: {
                display: "flex",
                padding: "24px",
                alignItems: "center",
                gap: "8px",
                alignSelf: "stretch",
                background: "#FFF",
                boxShadow:
                  "0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 2px 6px 2px rgba(0, 0, 0, 0.15)",
              },
              icn1: {
                id: "",
                name: "TOD.icnCorporateTPLCLogo",
                type: "Icon",
                icon: '<svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M13.5 1.5H12.75V0H11.25V1.5H3.75V0H2.25V1.5H1.5C0.675 1.5 0 2.175 0 3V15C0 15.825 0.675 16.5 1.5 16.5H13.5C14.325 16.5 15 15.825 15 15V3C15 2.175 14.325 1.5 13.5 1.5ZM13.5 15H1.5V5.25H13.5V15Z" fill="#51434B"/>\n</svg>\n',
                style: {
                  maxWidth: {
                    xs: "12px",
                    sm: "14px",
                    md: "18px",
                  },
                  width: "100%",
                  height: "auto",
                  backgroundColor: "rgba(255,255,255,1)",
                },
              },
              str1: {
                id: "",
                name: "TOD.strAlreadyHaveAccount",
                type: "Text",
                label: "Already have an account?",
                style: {
                  width: "fit-content",
                  fontWeight: 400,
                  fontSize: {
                    xs: "10px",
                    sm: "12px",
                    md: "14px",
                  },
                  lineHeight: "20px",
                  fontStyle: "regular",
                  textAlign: "left",
                  verticalAlign: "top",
                  whiteSpace: "nowrap",
                  wordBreak: "break-word",
                  color: "rgba(33,25,30,1)",
                },
              },
              str2: {
                id: "",
                name: "TOD.strLogin",
                type: "Text",
                label: "Login",
                style: {
                  color: "#601350",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                  textDecorationLine: "underline",
                  textDecorationStyle: "solid",
                  textDecorationSkipInk: "none",
                  textDecorationThickness: "auto",
                  textUnderlineOffset: "auto",
                  textUnderlinePosition: "from-font",
                },
              },
            },
            ...data?.subNavbarContent,
          }}
        >
          <Steper
            steps={data.steps}
            activeStep={activeStep}
            style={{ margin: "32px 0" }}
          />
          {data?.pages?.map((el, i) => {
            return (
              activeStep === i && (
                <Box width="fit-content" margin="0 auto">
                  <PageConverter key={i} jsonData={el} />
                  <Box
                    display="flex"
                    m="0 auto 100px"
                    justifyContent={activeStep === 0 ? "flex-end" : "space-between"}
                    alignItems="center"
                    width="100%"
                    minWidth="600px"
                  >
                    {activeStep !== 0 && (
                      <Button
                        disabled={activeStep === 0}
                        onClick={() => setActiveStep((prev) => prev - 1)}
                        style={{
                          maxWidth: {
                            xs: "52px",
                            sm: "60px",
                            md: "80px",
                          },
                          width: "100%",
                          backgroundColor: "rgba(0,0,0,0)",
                          border: "1px solid rgba(131,114,124,1)",
                          borderRadius: "100px",
                          display: "flex",
                          flexDirection: {
                            xs: "column",
                            sm: "column",
                            md: "column",
                          },
                          justifyContent: "center",
                          alignItems: "center",
                          gap: {
                            xs: "6px",
                            sm: "7px",
                            md: "8px",
                          },
                          height: "40px",
                          ...data?.ActionButton?.btn1?.style,
                          flexDirection: "row",
                        }}
                      >
                        <Typography
                          sx={{
                            width: "fit-content",
                            fontWeight: 500,
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                            },
                            lineHeight: "20px",
                            fontStyle: "medium",
                            textAlign: "center",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            wordBreak: "break-word",
                            color: "rgba(96,19,80,1)",
                            ...(data?.ActionButton?.btn1?.Text?.style || {}),
                          }}
                        >
                          {data?.ActionButton?.btn1?.Text?.label || "Back"}
                        </Typography>
                      </Button>
                    )}
                    <Button
                      disabled={activeStep === data?.pages?.length - 1}
                      onClick={() => setActiveStep((prev) => prev + 1)}
                      style={{
                        maxWidth: {
                          xs: "68px",
                          sm: "79px",
                          md: "105px",
                        },
                        width: "100%",
                        backgroundColor: "rgba(96,19,80,1)",
                        borderRadius: "100px",
                        display: "flex",
                        flexDirection: {
                          xs: "column",
                          sm: "column",
                          md: "column",
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        gap: {
                          xs: "6px",
                          sm: "7px",
                          md: "8px",
                        },
                        height: "40px",
                        ...data?.ActionButton?.btn2?.style,
                        flexDirection: "row",
                      }}
                    >
                      <Typography
                        sx={{
                          width: "fit-content",
                          fontWeight: 500,
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                          },
                          lineHeight: "20px",
                          fontStyle: "medium",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          wordBreak: "break-word",
                          color: "rgba(255,255,255,1)",
                          ...(data?.ActionButton?.btn2?.Text?.style || {}),
                        }}
                      >
                        {data?.ActionButton?.btn2?.Text?.label || "Continue"}
                      </Typography>
                    </Button>
                  </Box>
                </Box>
              )
            );
          })}
        </Layout>
      ) : (
        <PageConverter jsonData={data} />
      )}

      {loading && (
        <Loading
          message={
            longLoading
              ? "There are images and icons in this Figma file. It may take extra time to process. Please wait..."
              : ""
          }
        />
      )}

      <Box
        position="fixed"
        width="50%"
        display="flex"
        bottom="10px"
        gap={2}
        justifyContent={"center"}
        alignItems="center"
        zIndex={1000}
      >
        <Box
          sx={{
            maxWidth: "1400px",
            width: "100%",

            borderRadius: 2,
            boxShadow: 1,
            display: "flex",
            alignItems: "center",
            backgroundColor: "black",

            p: "8px 10px",
            gap: "20px",

            transform: showToolbar ? "translateX(0)" : "translateX(-200%)",
            transition: "transform 0.3s ease-in-out",
          }}
        >
          <TextField
            label="Figma Page URL"
            variant="outlined"
            value={figmaUrl}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                color: "white",
                "& fieldset": {
                  borderColor: "rgba(96,19,80,1)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(96,19,80,1)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgba(96,19,80,1)",
                },
              },
              "& .MuiInputLabel-root": {
                color: "white",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "white",
              },
            }}
            onChange={(e) => setFigmaUrl(e.target.value)}
          />
          <Button
            variant="contained"
            component="label"
            sx={{ width: "200px", backgroundColor: "rgba(96,19,80,1)" }}
            onClick={handleFigmaUrl}
          >
            Submit
          </Button>

          {/* {data  &&
            data?.page?.layout?.maxWidth?.md &&
            parseInt(data.page.layout.maxWidth.md) > 800 && (
              <Tooltip
                title={
                  data?.page?.name
                    ? `Create page: ${data.page.name}`
                    : "Load data first to create page"
                }
              >
                <span>
                  <Button
                    variant="contained"
                    sx={{
                      width: "140px",
                      backgroundColor: "rgba(19,96,80,1)",
                      "&:hover": {
                        backgroundColor: "rgba(19,96,80,0.8)",
                      },
                      "&:disabled": {
                        backgroundColor: "rgba(19,96,80,0.3)",
                      },
                    }}
                    onClick={handleCreatePage}
                    disabled={!data || !data.page?.name}
                  >
                    Create Page
                  </Button>
                </span>
              </Tooltip>
            )} */}
        </Box>
      </Box>
    </>
  );
};

export default PageConverterPage;
